export const defaultState = {
  brokersSummaryPagination: {
    currentPage: 1,
    itemsPerPage: 5
  }
};

const state = () => defaultState;

export default state;